import { Typography } from 'antd';
import dayjs from 'dayjs';
import { formatDollarsFromCents } from 'utilities/helpers';

const { Text } = Typography;

const PrecoOfferTitle = ({ offer }) => {
  const settlementPercentage = Math.round(offer.settlementPercentage * 100);
  const expirationDate = dayjs().add(offer.durationMonths, 'month');
  const offerSubtitle = `${settlementPercentage}% of balance, ${formatDollarsFromCents(offer.settlementBalance)} over ${offer.durationMonths} months`;
  const offerDeadline = `Deadline for settlement payment in full: ${expirationDate.format('LL')}`;

  return (
    <div style={{ padding: 'var(--spacing-xs) 0' }}>
      Pre-Chargeoff Settlement
      <br />
      <Text type="secondary">{offerSubtitle}</Text>
      <br />
      <Text type="secondary">{offerDeadline}</Text>
    </div>
  );
};

export default PrecoOfferTitle;
